// dashboard-agent-ia/src/pages/ocass/utils/sectors.js
// Utilitaires partagés côté frontend (miroir du backend)

// Title Case: "quincaillerie serigne daarou" → "Quincaillerie Serigne Daarou"
export const toTitleCase = (str) => {
  if (!str || typeof str !== 'string') return str
  return str
    .replace(/\s+/g, ' ')
    .split(' ')
    .map(word => {
      if (!word) return word
      return word
        .split(/(['-])/)
        .map(part => {
          if (part === "'" || part === '-') return part
          return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        })
        .join('')
    })
    .join(' ')
}

// Title Case "léger" pour la frappe en direct : capitalise juste la 1ère lettre de chaque mot
// SANS toucher aux espaces ni au reste (n'empêche jamais d'effacer)
export const titleCaseLive = (value) => {
  if (!value) return value
  // Capitalise la lettre qui suit un début de chaîne, un espace, une apostrophe ou un tiret
  return value.replace(/(^|[\s'-])([a-zà-ÿ])/g, (m, sep, ch) => sep + ch.toUpperCase())
}

export const SECTORS = [
  { id: 'alimentaire', label: 'Commerce alimentaire', hint: 'Denrées de première nécessité, boucheries, boulangeries' },
  { id: 'textile_mode', label: 'Textile et mode', hint: 'Friperie/Feugue-Diaye, tissus Wax/Bazin, prêt-à-porter' },
  { id: 'quincaillerie', label: 'Quincaillerie', hint: 'Matériaux de construction, ciment, fer, outillage' },
  { id: 'electronique', label: 'Électronique et technologie', hint: 'Smartphones, ordinateurs, électroménager' },
  { id: 'cosmetiques', label: 'Cosmétiques', hint: 'Produits de beauté, mèches, soins corporels' },
  { id: 'pieces_detachees', label: 'Pièces détachées', hint: 'Mécanique générale et accessoires automobiles' },
]

export const CATEGORIES_BY_SECTOR = {
  alimentaire: ['Riz', 'Huile', 'Sucre', 'Lait', 'Conserves', 'Boissons', 'Pain', 'Viande', 'Poisson', 'Légumes', 'Fruits', 'Épices', 'Pâtes', 'Café/Thé'],
  textile_mode: ['Wax', 'Bazin', 'Friperie', 'Prêt-à-porter homme', 'Prêt-à-porter femme', 'Chaussures', 'Sacs', 'Accessoires', 'Tissus', 'Voiles/Foulards', 'Enfants'],
  quincaillerie: ['Ciment', 'Fer à béton', 'Peinture', 'Outillage', 'Plomberie', 'Électricité', 'Quincaillerie générale', 'Carrelage', 'Bois', 'Visserie', 'Serrurerie'],
  electronique: ['Téléphones', 'Ordinateurs', 'Télévisions', 'Électroménager', 'Accessoires', 'Audio', 'Câbles/Chargeurs', 'Climatiseurs', 'Réfrigérateurs', 'Consoles/Jeux'],
  cosmetiques: ['Mèches', 'Maquillage', 'Soins visage', 'Soins corps', 'Parfums', 'Cheveux', 'Ongles', 'Savons', 'Crèmes', 'Accessoires beauté'],
  pieces_detachees: ['Filtres', 'Freins', 'Moteur', 'Pneus', 'Batteries', 'Huiles/Lubrifiants', 'Carrosserie', 'Électricité auto', 'Suspension', 'Accessoires'],
}

export const getCategoriesForSector = (sectorId) => CATEGORIES_BY_SECTOR[sectorId] || []
